// WIN Field App diagnostic logger -- thin wrapper around shared app_logger.
//
// Usage unchanged:
//   import { logError, logEvent, logWarn, logInfo } from "../field_logger"

import { createLogger, getLogContext, getPlatformSnapshot } from "./app_logger"
import db from "./field_db"

const logger = createLogger(db, "app_log")

export const logError   = logger.logError
export const logWarn    = logger.logWarn
export const logInfo    = logger.logInfo
export const logEvent   = logger.logEvent
export const purgeOldLogs = logger.purgeOldLogs
export const installGlobalErrorHandlers = logger.installGlobalErrorHandlers
export const setLogContext = logger.setLogContext
export const getDroppedLogCount = logger.getDroppedLogCount
export { getLogContext, getPlatformSnapshot }
